<template>
	

	<!-- showChild="true" relative="false" external="true" selectedTheme="white-theme" :theme="selectedTheme"  -->
		<b-col cols="2" class="nevmobileRow" :class="[{'collapsed' : collapsed}]">
				
		<sidebar-menu :menu="menu"  :relative="false"  :show-one-child="true" @toggle-collapse="onToggleCollapse" @item-click="onItemClick">
			
		<div slot="header" class="profile">	
			<div class="btn-reset btnSticky" data-ember-action="" @click="clickHandler" :class="[{'rotateIcocollapsed' : collapsed}]"> </div>	
			<b-row class="m-0"  :class="[{'posmenu' : posmenu}]">
				<b-col cols="12" md="12" class="text-left" > <b-link @click="clickHandler"><i class="fa fa-bars" aria-hidden="true"></i></b-link>
				</b-col>
			</b-row>	
			<b-row class="m-0">
					<div class="profileP" :class="[{'posmenuProfile' : posmenuProfile}]">
					
					<b-img alt="" v-if="this.$session.get('customer_info').image=='' || this.$session.get('customer_info').image==null" :src="$root.MEDIAPATH+'blank.jpg'" class="img-circle navpp" :class="[{'navppnew' : navppnew}]"></b-img> 
					<b-img   v-else :src="$root.MEDIAPATH+'profiles/'+this.$session.get('customer_info').image" class="img-circle navpp" alt="img" :class="[{'navppnew' : navppnew}]" ></b-img>
					</div>
				
				<!-- <b-col  cols="12" md="8" class="profile--namediv m-1">
					<span class="profile--name"> {{this.$session.get('customer_info').username}} </span>
				</b-col> -->				
			</b-row>
		</div>
		<!--<div slot="footer">footer</div>
		<span slot="toggle-icon">toggle-icon</span>
		<span slot="dropdown-icon">dropdown-icon</span> -->
		<span slot="toggle-icon"  ref="collepsmypanel"><i class="fa fa-arrows-h" aria-hidden="true"></i></span>
		</sidebar-menu>
      </b-col>                 
                  
						
                    
               

</template>
<script>

  import '@/assets/nave.scss';
  export default {
    name: "TreeviewPage",
	props: {
		relative: {
		  type: Boolean,
		  default: true
		}
	
	},
    components: {
      //mdbContainer,
     // mdbRow,
      //mdbIcon,
     //mdbTreeview,
      //mdbTreeviewItem
    },
	data() {
		return{	
				collapsed: false,
				posmenu: true,
				posmenuProfile: false,
				navppnew: false,
				themes: ['', 'white-theme'],
				selectedTheme: 'white-theme',
				menu: [
				   {
						header: true,
						/*title: 'Example' */
					  },
					  /*{
						title: 'Badge',
						icon: 'fa fa-cog',
						badge: {
						  text: 'new',
						  class: 'default-badge'
						}
					  },*/
					  {
						href: '/seller/dashboard',
						title: 'Dashboard',
						icon: 'fa fa-dashboard',
						
					  },
					  {
						href: '/seller/profile',
						title: 'Manage Profile',
						icon: 'fa fa-user',
						/*child: [
						  {
							href: '/seller/profile',
							title: 'Profile',
							icon: 'fa fa-file-alt'
						  }
						  
						]*/
					  },
					  {
						href: '/seller/wallet',
						title: 'My Wallet',
						icon: 'fa fa-google-wallet',
						
					  },	
					   {
							href: '/seller/brands',
							title: 'Manage Brands',
							icon: 'fa fa-picture-o'
						},
						{
						href: '',
						title: 'Manage Products',
						icon: 'fa fa-product-hunt',
						child: [
						  {
							href: '/seller/products',
							title: 'Products List',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/seller/products-import',
							title: 'Import Product',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/seller/import-stock',
							title: 'Import Stock',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/seller/products-outofstock',
							title: 'Out of stock',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/seller/products-needtostock',
							title: 'Need to stock',
							icon: 'fa fa-file-alt'
						  }
						]
					  },
					  {
						href: '',
						title: 'Manage Promotion',
						icon: 'fa fa-first-order',
						child: [
						{
							href: '/seller/import-commission',
							title: 'Import Commission',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/seller/import-promotion',
							title: 'Import Discount',
							icon: 'fa fa-file-alt'
						  },
						  /* {
							href: '/seller/import-promotion',
							title: 'Import Promotions',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/seller/promotion-history',
							title: 'Promotions History',
							icon: 'fa fa-file-alt'
						  },*/
						  
						]
					  },{
						href: '',
						title: 'Manage Orders',
						icon: 'fa fa-first-order',
						child: [
						  {
							href: '/seller/orders',
							title: 'Sales Order',
							icon: 'fa fa-file-alt'
						  },
						  /*{
							href: '',
							title: 'Pending Orders',
							icon: 'fa fa-file-alt'
						  },*/
						  {
							href: '/seller/cancelled-orders',
							title: 'Cancelled Orders',
							icon: 'fa fa-file-alt'
						  },{
							href: '/seller/returned-orders-queue',
							title: 'Returned Queue',
							icon: 'fa fa-file-alt'
						  },{
							href: '/seller/returned-orders',
							title: 'Returned Orders',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '',
							title: 'Repeat Orders',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '',
							title: 'Tracking',
							icon: 'fa fa-file-alt'
						  },{
							href: '/seller/myorders',
							title: 'Your Orders',
							icon: 'fa fa-file-alt'
						  }
						]
					  },
					  {
						href: '',
						title: 'Reports',
						icon: 'fa fa-bar-chart',
						child: [
						  {
							href: '/seller/reports/orders',
							title: 'Order Report',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/seller/reports/commissions',
							title: 'Commission Report',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/seller/reports/stocks',
							title: 'Stock Report',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '',
							title: 'Repeat Orders',
							icon: 'fa fa-file-alt'
						  }
						  
						]
					  },
					  { 
						href: '/seller/videos',
						title: 'My Videos',
						icon: 'fa fa-video-camera',
						
					  },
					 
							
		]

		};
	},
	methods: {
		onToggleCollapse(collapsed) {
			console.log('Ram Ram'+collapsed);
			 this.collapsed = collapsed;
			 this.posmenuProfile = collapsed;
			 this.navppnew = collapsed;
			 if(!collapsed){
				this.posmenu = true;
				
			 }else{
				this.posmenu = false;
				
			 }
		},
		onItemClick(event, item, node) {
		console.log(event+','+item+','+node);
		}, 	
		clickHandler() {
			this.$refs.collepsmypanel.click();
		}	

	}
	
  };
</script>
<style  lang="scss">



</style>